import { apiFetch } from '@/platform/lib/api';
import type { SiteAppearanceAdmin, SiteAppearancePublic } from './types';

export function fetchSiteAppearance() {
  return apiFetch<SiteAppearancePublic>('/site/appearance');
}

export function fetchAdminSiteAppearance() {
  return apiFetch<SiteAppearanceAdmin>('/admin/site/appearance');
}

export function patchAdminSiteAppearance(body: Partial<SiteAppearanceAdmin>) {
  return apiFetch<SiteAppearanceAdmin>('/admin/site/appearance', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export type SiteBackgroundUploadResponse = {
  uploadUrl: string;
  objectPath: string;
  publicUrl: string;
  expiresAt: string;
};

export function requestSiteBackgroundUpload(filename: string, contentType: string) {
  return apiFetch<SiteBackgroundUploadResponse>('/uploads/signed-url', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      purpose: 'site_background',
      filename,
      contentType,
    }),
  });
}
